import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';

const AreYouSureDailogUi = ({message ,  state, setState, handleClick}) => {

  const handleClose = () => {
    setState(false);
  };

  return (
    <>
      <Dialog open={state} onClose={handleClose}>
        <DialogTitle>Are You Sure</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClick}>Submit</Button>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AreYouSureDailogUi;
